<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 550.801 550.801"
  style="enable-background: new 0 0 550.801 550.801"
  xml:space="preserve"
>
  <g>
    <path
      d="M488.426,197.019H475.2v-63.816c0-0.401-0.063-0.799-0.116-1.205c-0.021-2.534-0.827-5.023-2.562-6.992L366.325,3.691
		c-0.032-0.031-0.063-0.042-0.085-0.073c-0.633-0.707-1.371-1.298-2.151-1.804c-0.231-0.158-0.464-0.287-0.706-0.422
		c-0.676-0.366-1.393-0.675-2.131-0.896c-0.2-0.053-0.38-0.135-0.58-0.19C359.87,0.119,359.037,0,358.193,0H97.2
		c-11.918,0-21.6,9.693-21.6,21.601v175.413H62.377c-17.049,0-30.873,13.818-30.873,30.87v160.542
		c0,17.044,13.824,30.876,30.873,30.876h13.224V529.2c0,11.907,9.682,21.601,21.6,21.601h356.4c11.907,0,21.6-9.693,21.6-21.601
		V419.302h13.226c17.044,0,30.871-13.827,30.871-30.87V227.89C519.297,210.838,505.47,197.019,488.426,197.019z M453.601,523.353
		H97.2V419.302h356.4V523.353z M193.839,363.003c8.377,0,15.082-0.949,17.951-2.384V326.88h-24.888v-28.482h60.064v84.95
		c-11.243,3.828-32.558,9.092-53.844,9.092c-29.436,0-50.733-7.415-65.573-21.774c-14.839-13.874-22.971-34.937-22.729-58.62
		c0.232-53.602,39.248-84.229,92.13-84.229c20.812,0,36.837,4.066,44.74,7.895l-7.657,29.186
		c-8.852-3.828-19.863-6.932-37.579-6.932c-30.375,0-53.359,17.23-53.359,52.157C143.101,343.386,163.931,363.003,193.839,363.003z
		 M275.456,390.762V229.495h36.605v161.267H275.456z M438.181,296.252v29.668h-57.913v64.842H343.66V229.495h98.597v29.9h-61.989
		v36.856H438.181z M453.601,197.019H97.2V21.605h250.193v110.51c0,5.967,4.841,10.8,10.8,10.8h95.407V197.019z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
